export default __webpack_public_path__ + "static/media/four.589b17f6.png";